<template>
  <div class="creative-info">
    <ColumnBlock :title="title" @clear="onClear" @show-config-modal="onShowConfigModal">
      <div v-if="isWxGamePlayable" slot="title" class="block-title" style="position: relative">
        <h4>试玩素材</h4>
        <span>{{ configForm.creatives.length }}/200 </span>
      </div>

      <div v-else slot="title" class="block-title recombine-title" style="position: relative">
        <h4>{{ props.title }}</h4>
        <span>{{ configForm.creatives.length }}/200 </span>
        <template
          v-if="
            configForm.creatives.length &&
            configForm.recombineHelpers.distributeForm &&
            configForm.recombineHelpers.distributeOriginIds &&
            configForm.recombineHelpers.distributeOriginIds.length
          "
        >
          <el-popover placement="bottom" width="160" trigger="hover">
            <div>
              <el-checkbox v-model="recombineDistrubuteForm.groupAsSameImageId"></el-checkbox>
              <span style="font-size: 12px">&ensp;同编号素材优先组合</span>
            </div>
            <el-button slot="reference" type="text" @click="onCreativeGroupsReCombine" class="recombine" :loading="recombineLoading">
              一键打乱
            </el-button>
          </el-popover>

          <CreativeDistributor class="distributor-position" :form.sync="recombineDistrubuteForm" recombine></CreativeDistributor>
        </template>
      </div>

      <MaterialFormPreview :groups="configForm.creatives"></MaterialFormPreview>
    </ColumnBlock>

    <ConfigDrawer
      v-model="showCreativeModal"
      title="创意信息"
      size="800px"
      :before-close="formValidator"
      @confirm="onMaterialConfigConfirm"
    >
      <div slot="title">
        <span>创意组配置</span>
        <span class="config-count">已选择{{ creativeFormGroups.length }}个创意组</span>
      </div>

      <div class="creative-groups">
        <div class="group-item">
          <el-tag
            v-for="(group, index) in creativeFormGroups"
            :key="index"
            :closable="creativeFormGroups.length > 1"
            :effect="currCreativeGroupIndex === index ? 'dark' : 'light'"
            :type="currCreativeGroupIndex === index ? '' : 'info'"
            disable-transitions
            size="medium"
            @click="currCreativeGroupIndex = index"
            @close="onCreativeGroupItemRemove(index)"
          >
            <span class="group-name"> 创意组{{ index + 1 }}</span>
            <span class="copy-icon el-icon-copy-document" @click.stop="onCreativeGroupDuplicate(index)"> </span>
          </el-tag>

          <el-button type="text" v-if="creativeFormGroups.length < 200" @click="onCreativeGroupAdd">+新增创意组</el-button>
        </div>
        <div>
          <el-button type="primary" @click="onShowCreativeSelector(true, isWxGamePlayable, carouselCreativeMaterialType)">
            智能创建创意组
          </el-button>
        </div>
      </div>
      <MaterialForm
        v-for="(group, index) in creativeFormGroups"
        :key="index + group.creative_name"
        :form.sync="creativeFormGroups[index]"
        :len="selectedMaterialLength"
        v-show="currCreativeGroupIndex === index"
        :ref="(el) => getRefInstanceInOrder(el, index)"
        :is-search-ad="isSearchAd"
        :is-wxgame-playable="isWxGamePlayable"
        :is-carousel-three-image="isCarouselThreeImage"
        :is-carousel-three-video="isCarouselThreeVideo"
        class="config-form ghost-button-styles"
        @show-material-selector="onShowCreativeSelector($event, isWxGamePlayable)"
        @replace="onShowRepalceMaterialSelector"
      >
      </MaterialForm>
    </ConfigDrawer>

    <!-- 素材选择弹窗 -->
    <el-dialog
      :visible.sync="showSelectorModal"
      custom-class="material-selector-dialog"
      :close-on-click-modal="false"
      width="1200px"
      @close="onSelectorClose"
    >
      <template v-if="isDistributionMode" slot="title">
        <div class="custom-creative-selector-title">
          <h4 class="title-text">批量添加创意组</h4>

          <div class="center-element">
            <template v-if="isWxGamePlayable">&ensp;</template>
            <CreativeDistributor
              v-else
              :form.sync="distributeForm"
              :material-type="carouselMaterialType"
              :max-per-group="carouselMaterialType ? 3 : 15"
            ></CreativeDistributor>
          </div>
          <el-button class="creative-name-import" type="text" @click="onShowImportModal">批量导入素材</el-button>
        </div>
      </template>

      <template v-else slot="title">
        <div class="custom-creative-selector-title">
          <h4 class="title-text">选择素材</h4>
        </div>
      </template>

      <AssetsSelector
        ref="assetsSelectorRef"
        v-bind="{ ...selectorProps, visible: showSelectorModal, selectedGameId }"
        :before-submit="beforeSelectorSubmit()"
        @close="onSelectorClose"
        @confirm="onSelectorConfirm($event)"
      >
        <!-- 试玩选择结束页专用 -->
        <template v-if="isWxGamePlayable" v-slot:assetType="{ getData }">
          <el-radio v-model="selectorProps.assetType" @change="getData" :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]"> 图片 </el-radio>
        </template>

        <template v-else-if="carouselMaterialType" v-slot:assetType="{ getData }">
          <el-radio v-model="selectorProps.assetType" @change="getData" :label="MATERIAL_TYPE_ID[carouselMaterialType]">
            {{ carouselMaterialType === MATERIAL_TYPE.IMAGE ? '图片' : '视频' }}
          </el-radio>
        </template>

        <template v-else v-slot:assetType="{ getData }">
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.VIDEO]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]"
          >
            视频
          </el-radio>

          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.IMAGE]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]"
          >
            图片
          </el-radio>

          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.GROUP_IMAGE]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.GROUP_IMAGE]"
          >
            组图
          </el-radio>

          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.POSTER]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.POSTER]"
          >
            封面
          </el-radio>

          <el-radio v-model="selectorProps.assetType" @change="getData" :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.FAV]"> 个人收藏 </el-radio>
        </template>

        <template #mediatag v-if="materialTagList && materialTagList.length">
          <el-select
            style="width: 110px"
            popper-class="creative-selector-el-select-popper"
            :popper-append-to-body="false"
            v-model="selectorProps.form.media_tag"
            disabled
          >
            <el-option v-for="item in materialTagList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </template>

        <template v-slot:sizes="{ getData, width }">
          <el-select
            :style="{ width }"
            popper-class="creative-selector-el-select-popper"
            :popper-append-to-body="false"
            :disabled="replaceProps.groupImageIndex > -1"
            v-model="selectorProps.form.sizes"
            multiple
            collapse-tags
            clearable
            @change="getData"
          >
            <!-- 根据当前选择素材的类型来获取尺寸下拉数据 -->
            <el-option
              v-for="item in MATERIAL_TYPE_SIZES_V3[selectorProps.assetType]"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </template>
      </AssetsSelector>

      <CreativeImportModal v-model="showImportModal" @confirm="onCreativeImportConfirm"></CreativeImportModal>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, toRefs, inject, computed, nextTick } from 'vue'
import { Message } from 'view-design'
import { clone, groupBy } from '@/common/js/just.js'
import ColumnBlock from '@/views/create/bytedance/components/layout/block.vue'
import ConfigDrawer from '@/views/create/bytedance/components/layout/drawer.vue'
import MaterialForm from './material-config-form.vue'
import MaterialFormPreview from './components/creative-preview/index.vue'
import { AssetsSelector, makeSelectorForm } from '@/components/material-selector/index.js'
import CreativeImportModal from '@/views/create/bytedance/components/creative/components/creative-import/index.vue'
import CreativeDistributor from './components/creative-distributor/index.vue'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import { MATERIAL_TYPE_SIZES_V3, MATERIAL_IMAGE_GROUP_TYPE, MATERIAL_SIZES } from '@/views/create/gdt/model/creative-const.js'

import { hasSameMaterialSize, useCreativeGroups, useCreativeSelector, useCreativeImportModal } from '../../hooks/useGdtMaterials.js'
import { useGdtCreativeComputes } from '../../hooks/utils/creative.js'
import { AD_MARKETING_SCENE } from '../../../model/project-const'
// eslint-disable-next-line
const props = defineProps({
  title: String
})
const { title } = toRefs(props)

const { getAdAccount } = inject('localStates')
const { configForm, updateConfigForm } = inject('configForm')

// 素材管控需要传入的游戏id
const selectedGameId = computed(() => configForm.value.planForm?.game_id?.id || 0)
const isSearchAd = computed(() => configForm.value.planForm?.ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH)
const promotedObjectId = computed(() => configForm.value.planForm.promotedObject?.promoted_object_id)

const creativeForm = computed(() => configForm.value.creativeForm)
const {
  isWxGamePlayable,
  isCarouselThreeImage,
  isCarouselThreeVideo,
  carouselMaterialType: carouselCreativeMaterialType
} = useGdtCreativeComputes(creativeForm)
const showCreativeModal = ref(false)
const {
  creativeFormRef,
  currGroup,
  creativeFormGroups,
  currCreativeGroupIndex,
  onCreativeGroupAdd,
  onCreativeGroupItemRemove,
  onCreativeGroupDuplicate,
  onBeforeConfigConfirm,
  onUpdateCreativeForm
} = useCreativeGroups(configForm)

/**
 * @description: 保证creativeFormRef每个组件在数组内的顺序与creativeFormGroups一致
 * @description: 否则 src/views/create/gdt/template/hooks/useGdtMaterials.js onUpdateCreativeForm 组件更新会发生错乱
 * @param {*} el
 * @param {*} index
 */
function getRefInstanceInOrder(el, index) {
  if (el) {
    creativeFormRef.value[index] = el
  }
}

const {
  selectedMaterialLength,
  replaceProps,
  recombineLoading,
  showSelectorModal,
  selectorProps,
  distributeForm,
  recombineDistrubuteForm,
  isDistributionMode,
  isUploadGroupImageMode,
  carouselMaterialType,
  groupImageType,
  seletedMaterialRadioDiasbled,
  materialTagList,
  onShowCreativeSelector,
  onShowRepalceMaterialSelector,
  onSelectorBeforeSubmit,
  onCarouselSelectorBeforeSubmit,
  onSelectorClose,
  onSelectorConfirm,
  onCreativeGroupsReCombine
} = useCreativeSelector(getAdAccount, currGroup, creativeFormGroups, onUpdateCreativeForm, configForm, updateConfigForm)

const { assetsSelectorRef, showImportModal, onShowImportModal, onCreativeImportConfirm } = useCreativeImportModal()

function onShowEndImageMaterialSelector() {
  selectorProps.value = {
    ...selectorProps.value,
    max: 1,
    videoId: 0,
    assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE],
    form: { ...makeSelectorForm(), sizes: [MATERIAL_SIZES.SIZE_1280_720] }
  }

  showSelectorModal.value = true
}

function beforeSelectorSubmit() {
  if (isDistributionMode.value) {
    return onSelectorBeforeSubmit
  }

  if (isUploadGroupImageMode.value) {
    return onProceduralSelectorBeforeSubmit
  }

  if (carouselMaterialType.value) {
    return onCarouselSelectorBeforeSubmit
  }

  if (isSearchAd.value) {
    return onSearchAdGroupImageBeforeSubmit
  }

  return null
}

/**
 * @description: 配置弹窗确认
 */
async function onMaterialConfigConfirm() {
  try {
    for (const i in creativeFormGroups.value) {
      const group = creativeFormGroups.value[i]
      const lens = Object.values(group.selectedMaterials).reduce((total, curr) => total + curr.length, 0)
      if (lens === 0) {
        currCreativeGroupIndex.value = Number(i)
        return Message.warning(`${group.creative_name}：素材不能为空`)
      }

      if (carouselCreativeMaterialType.value) {
        const materialName = carouselCreativeMaterialType.value === MATERIAL_TYPE.IMAGE ? '图片' : '视频'
        const carouselMaterials = group.selectedMaterials[carouselCreativeMaterialType.value] || []
        const carouselMaterialLength = carouselMaterials.length
        if (lens !== 3 || carouselMaterialLength !== 3) {
          currCreativeGroupIndex.value = Number(i)
          return Message.warning(`${group.creative_name}：必须选择3个${materialName}素材`)
        }
        if (!hasSameMaterialSize(carouselMaterials)) {
          currCreativeGroupIndex.value = Number(i)
          return Message.warning(`${group.creative_name}：3个${materialName}素材宽高尺寸必须一致`)
        }
      }

      const imageList = group.selectedMaterials.image_list
      if (imageList?.length) {
        const hasPlaceholderItem = imageList.some((item) => item.placeholder === true)

        if (hasPlaceholderItem) {
          currCreativeGroupIndex.value = Number(i)
          return Message.warning(`${group.creative_name}：请等待组图素材生成完成`)
        }
      }
    }

    updateConfigForm({
      ...configForm.value,
      creatives: clone(creativeFormGroups.value)
    })
    showCreativeModal.value = false
  } catch (e) {
    console.log('eeeee output: ', e)
  }
}

/**
 * @description: 搜索广告组图素材选择校验
 * @param {*} images
 * @param {*} callbacks
 * @return {*}
 */
function onSearchAdGroupImageBeforeSubmit(images, callbacks) {
  const { done, fail } = callbacks || {}
  for (const image of images) {
    if (image.type === 'image_list') {
      if (image.image_list_urls.length !== 4) {
        return fail('搜索计划只能选择4图的组图')
      }
    }
  }
  done()
}

/**
 * @description: 组图素材选择校验
 * @param {*} images
 * @param {*} callbacks
 * @return {*}
 */
function onProceduralSelectorBeforeSubmit(images, callbacks) {
  const { done, fail } = callbacks || {}
  let msg = ''
  switch (groupImageType.value) {
    case MATERIAL_IMAGE_GROUP_TYPE.THREE_IMAGE:
      if (images.length !== 3) msg = '请选择3张图片'
      break
    case MATERIAL_IMAGE_GROUP_TYPE.FOUR_IMAGE:
      if (images.length !== 4) msg = '请选择4张图片'
      break
    case MATERIAL_IMAGE_GROUP_TYPE.SIX_IMAGE:
      if (images.length !== 6) msg = '请选择6张图片'
      break
    default:
      if (images.length !== 9) msg = '请选择9张图片'
      break
  }

  // 判断图片类型是否相同
  const suffix = images[0].url.split('.').pop()
  const isSameSuffix = images.every((item) => {
    const suf = item.url.split('.').pop()
    return suf === suffix
  })

  if (!isSameSuffix) msg = '请选择同类型图片'

  // 判断图片尺寸是否相同
  const { width, height } = images[0]
  const shape = `${width}*${height}`
  const isSameShape = images.every((item) => {
    const { width, height } = item
    const sh = `${width}*${height}`
    return sh === shape
  })
  if (!isSameShape) msg = '请选择同尺寸图片'

  msg ? fail(msg) : done()
}

function onClear() {
  updateConfigForm({ ...configForm.value, creatives: [] })
}

const showPlanInfoModal = false
function onShowConfigModal() {
  if (!configForm.value.accounts.length) {
    return Message.warning('请先添加账号')
  }
  if (!Object.keys(configForm.value.creativeForm).length) {
    return Message.warning('请先配置创意信息')
  }

  // 打开配置弹窗抽屉默认切换到第一个创意组
  currCreativeGroupIndex.value = 0
  showCreativeModal.value = true
  creativeFormGroups.value = []

  const { creatives } = configForm.value
  // 如果已存在配置信息，直接覆盖
  if (creatives?.length) {
    nextTick(() => {
      creativeFormGroups.value = clone(creatives)
    })
  }
}
function formValidator(done) {
  done()
}
function onPlanConfigConfirm() {}
</script>

<style lang="scss" scoped>
.config-form {
  padding: 0 20px;
}
.config-count {
  font-size: 14px;
  margin-left: 20px;
}

.recombine-title {
  display: flex;
  align-items: center !important;
  .distributor-position {
  }
  .recombine {
    padding: 0;
    margin-left: 10px;
  }
}

.custom-creative-selector-title {
  display: flex;
  align-items: center;
  .title-text {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
    font-weight: normal;
  }

  .center-element {
    margin-right: 20px;
    flex: 1;
  }

  .creative-name-import {
    margin-right: 40px;
  }
}
.creative-groups {
  border-bottom: 1px solid #eaeaea;
  padding: 12px;
  background-color: #fff;
  z-index: 10;

  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  .group-item {
    .el-tag {
      cursor: pointer;
      font-size: 14px;
      margin-right: 12px;
      margin-bottom: 4px;
      .group-name {
        display: inline-block;
        width: 52px;
      }

      .copy-icon {
        font-size: 12px;
        margin-left: 10px;
        // display: none;
      }
    }
  }
}
::v-deep .image-error-placeholder {
  background: #c0c4cc;
  color: #fff;
  border-radius: 4px;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
}
</style>
